import { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import { Stack } from "expo-router";
import { PublicGuard } from "./auth/guards/RouteGuards";
import SignupView from "./auth/views/SignupView";
import Colors from "../Resources/Color";
import { useCoachStore } from "./contexts/CoachStoreContext";

export default function SignupPage() {
  const coach = useCoachStore();

  useEffect(() => {
    if (typeof document === "undefined") return;

    document.title = "Efort Coach - Sign up";

    const upsertMetaByName = (name, content) => {
      const existing = document.querySelector(`meta[name="${name}"]`);
      const meta = existing || document.createElement("meta");
      meta.setAttribute("name", name);
      meta.setAttribute("content", content);
      if (!existing) document.head.appendChild(meta);
    };

    const upsertCanonical = (href) => {
      const existing = document.querySelector('link[rel="canonical"]');
      const link = existing || document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("href", href);
      if (!existing) document.head.appendChild(link);
    };

    upsertMetaByName(
      "description",
      "Start your free 10-day trial of Efort Coach. Create an account to access the coaching platform and manage training blocks, athletes and competitions."
    );
    upsertCanonical("https://app.efortcoach.com/signup");
  }, []);

  return (
    <PublicGuard>
      <Stack.Screen
        options={{ headerShown: false, title: "Efort Coach - Sign up" }}
      />
      <View style={styles.containerLogin}>
        <SignupView coach={coach} />
      </View>
    </PublicGuard>
  );
}

const styles = StyleSheet.create({
  containerLogin: {
    backgroundColor: Colors.backgroundColor,
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    flex: 1,
    width: "100%",
    height: "100%",
  },
});
